import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Card, Empty, Tag } from "antd";
import Grid from "@mui/material/Grid";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import {  ExpandMore } from "@mui/icons-material";
import AddPolicyInputFields from "./AddPolicy/AddPolicy";
import LeaveRequest from "./LeaveRequest/LeaveRequest";
import EmployeesOnLeave from "./EmployeeOnLeave/EmployeesOnLeave";
import Footer from "Common/Footer";
import { useNavigate } from "react-router-dom";
import TimeOffService from "Services/AdminServices/ReportServices/TimeOffService";
import { LeaveTypeEnum } from "Constants/Enums/LeavePolicyEnum";

function TimeOff() {
  const {
    handleRemovePolicy,
    expanded,
    toggleExpanded,
    showDetail,
    showAddPolicy,
    leavePolicies,
    policyDetails,
    handleDetail,
    handleAddPolicy,
    handlePolicySubmissionSuccess,
    loadedData,
    loading,
    chartData,
    fetchChartData,
    getLeaveTypeLabel,
  } = TimeOffService();

  const navigate = useNavigate();

  const getLeaveTypeColor = (leaveType) => {
    const colors = {
      [LeaveTypeEnum.Sick]: "blue",
      [LeaveTypeEnum.Casual]: "green",
      [LeaveTypeEnum.Maternity]: "pink",
      [LeaveTypeEnum.Paternity]: "orange",
      [LeaveTypeEnum.Unpaid]: "red",
    };
    return colors[leaveType] || "default";
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* === MAIN SECTION === */}
      {showDetail && showAddPolicy && (
        <>
          <Card
            title="Time Off"
            className="card-professional"
            extra={
              <Button type="default" onClick={() => navigate(-1)}>
                Back
              </Button>
            }
            style={{
              margin: "auto",
              maxWidth: "95%",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Grid container spacing={3} alignItems="stretch">
              {/* ==== LEFT SIDE (Leave Policy List) ==== */}
              <Grid item xs={12} lg={5}>
                <Card
                  title="Leave Policy"
                  extra={
                    <Button type="default" onClick={handleAddPolicy}>
                      <i className="fa fa-plus-circle" aria-hidden="true"></i>&nbsp;Add Policy
                    </Button>
                  }
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 1px 5px rgba(0,0,0,0.08)",
                    height: "100%",
                  }}
                  styles={{ body: { padding: "16px" } }}
                >
                  {loading && !loadedData ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <p style={{ fontSize: "medium" }}>Loading...</p>
                    </div>
                  ) : leavePolicies.length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        {leavePolicies
                          .slice(0, expanded ? leavePolicies.length : 4)
                          .map((policy, index) => (
                            <Card
                              key={
                                policy.leavepolicyId ?? policy.id ?? `${policy.policyName}-${index}`
                              }
                              size="small"
                              style={{
                                cursor: "pointer",
                                borderRadius: "8px",
                                border: "1px solid #e8e8e8",
                                position: "relative",
                                paddingRight: "40px",
                                transition: "all 0.3s ease",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              }}
                              styles={{ body: { padding: "12px 16px" } }}
                              onClick={() => handleDetail(policy)}
                              hoverable
                            >
                              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {policy.policyName}
                                  </span>
                                  <Tag
                                    color={getLeaveTypeColor(policy.leaveType)}
                                    style={{
                                      margin: 0,
                                      fontSize: "11px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {getLeaveTypeLabel(policy.leaveType)}
                                  </Tag>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span style={{ fontSize: "13px", color: "#666" }}>
                                    {policy.grantedDaysPerYear} days/year
                                  </span>
                                  <span style={{ fontSize: "12px", color: "#999" }}>
                                    {policy.policyYear}
                                  </span>
                                </div>
                              </div>

                              {/* Delete Icon
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "12px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  padding: "4px",
                                  borderRadius: "4px",
                                  backgroundColor: "#fff",
                                  border: "1px solid #ff4d4f",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  console.log("policy",policy)
                                  handleRemovePolicy(policy.id);
                                }}
                              >
                                <i
                                  className="fas fa-times"
                                  style={{ color: "red", fontSize: "12px" }}
                                />
                              </div> */}
                            </Card>
                          ))}

                        {leavePolicies.length > 4 && (
                          <div
                            style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}
                          >
                            <Button
                              type="default"
                              onClick={toggleExpanded}
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                              }}
                            >
                              {expanded ? "Show Less" : "Show More"}
                              <ExpandMore
                                style={{
                                  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              />
                            </Button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "120px",
                      }}
                    >
                      <Empty description="No Policy Available" />
                    </div>
                  )}
                </Card>
              </Grid>

              {/* ==== RIGHT SIDE (Chart) ==== */}
              <Grid item xs={12} lg={7} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%", maxWidth: "650px" }}>
                  {chartData &&
                  chartData.datasets &&
                  chartData.datasets[0].data.some((val) => val > 0) ? (
                    <GradientLineChart title="Vacation Report" height="20rem" chart={chartData} />
                  ) : (
                    <Card style={{ textAlign: "center" }}>
                      <Empty description="No Leave Data Available" imageStyle={{ height: 60 }}>
                        <Button className="btn-primary" onClick={fetchChartData}>
                          Refresh Data
                        </Button>
                      </Empty>
                    </Card>
                  )}
                </div>
              </Grid>
            </Grid>
          </Card>

          <br />
          <LeaveRequest />
          <br />
          <EmployeesOnLeave upcomingOnly={true} />
        </>
      )}

      {/* === POLICY DETAIL VIEW - CENTERED AND IMPROVED === */}
      {!showDetail &&
        policyDetails.length > 0 &&
        policyDetails.map((policy, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "800px", // Increased width for better space utilization
              }}
            >
              <Card
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h4 style={{ margin: 0, color: "#1890ff", fontWeight: "600" }}>
                      Policy Details
                    </h4>
                    <Button type="default" onClick={handlePolicySubmissionSuccess}>
                      Back to Policies
                    </Button>
                  </div>
                }
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  border: "1px solid #f0f0f0",
                }}
              >
                <div style={{ padding: "20px" }}>
                  {/* Policy Details in Grid Layout */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "20px",
                      marginBottom: "24px",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <label style={{ fontWeight: "600", color: "#666", fontSize: "14px" }}>
                        Policy Name
                      </label>
                      <span style={{ fontSize: "16px", color: "#333" }}>{policy.policyName}</span>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <label style={{ fontWeight: "600", color: "#666", fontSize: "14px" }}>
                        Leave Type
                      </label>
                      <Tag
                        color={getLeaveTypeColor(policy.leaveType)}
                        style={{
                          fontSize: "14px",
                          padding: "4px 8px",
                          width: "fit-content",
                        }}
                      >
                        {getLeaveTypeLabel(policy.leaveType)}
                      </Tag>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <label style={{ fontWeight: "600", color: "#666", fontSize: "14px" }}>
                        Granted Days
                      </label>
                      <span style={{ fontSize: "16px", color: "#333" }}>
                        {policy.grantedDaysPerYear} days/year
                      </span>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <label style={{ fontWeight: "600", color: "#666", fontSize: "14px" }}>
                        Policy Year
                      </label>
                      <span style={{ fontSize: "16px", color: "#333" }}>{policy.policyYear}</span>
                    </div>
                  </div>

                  {/* Description - Full Width */}
                  {policy.description && (
                    <div
                      style={{
                        borderTop: "1px solid #f0f0f0",
                        paddingTop: "20px",
                        marginTop: "20px",
                      }}
                    >
                      <label
                        style={{
                          fontWeight: "600",
                          color: "#666",
                          fontSize: "14px",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Description
                      </label>
                      <div
                        style={{
                          backgroundColor: "#fafafa",
                          padding: "16px",
                          borderRadius: "6px",
                          border: "1px solid #f0f0f0",
                        }}
                      >
                        <span style={{ fontSize: "15px", color: "#333", lineHeight: "1.5" }}>
                          {policy.description}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </div>
        ))}

      {!showAddPolicy && <AddPolicyInputFields onSubmitSuccess={handlePolicySubmissionSuccess} />}

      <Footer />
    </DashboardLayout>
  );
}

export default TimeOff;
